import { makeAutoObservable } from "mobx";

class AuthModel {
  email: string | undefined = undefined;
  jwtToken: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  isAuthenticated = (): boolean => {
    return this.jwtToken !== null;
  };

  setEmail = (email: string | undefined): void => {
    this.email = email;
  };

  setJwtToken = (token: string | null): void => {
    this.jwtToken = token;
  };
}

export const authModel = new AuthModel();
